export default class ResetCredential {
  constructor(email, password, confirmPassword, token) {
    this.email = email;
    this.password = password;
    this.password_confirmation = confirmPassword;
    this.token = token;
  }
}
